import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Box,
  Image,
  Flex,
  Text,
  Heading
} from '@chakra-ui/core'
import * as React from 'react'
import { images } from '../../theme'

const AuthStatusModal: React.FC<{ isOpen: boolean; onOpen: () => void; onClose: () => void }> = ({
  isOpen,
  onClose
}) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered size="full">
      <ModalOverlay />
      <ModalContent h="100%" overflow="hidden" position="fixed" top={0} m={0}>
        <ModalBody h="100%" w="100%" overflow="hidden" m={0}>
          <Flex h="100%" w="100%" direction="column" justify="center" align="center">
            <Box w="80%">
              <Flex direction="row" justify="flex-start" align="center" w="100%">
                <Button variant="ghost" onClick={onClose}>
                  Back to sign in
                </Button>
              </Flex>
              <Flex direction="row" justify="center" align="center" w="100%" p={3}>
                <Flex w="50%" h="100%" justify="center" align="center" p={6}>
                  <Image src={images.notFound} />
                </Flex>
                <Box w="50%" h="100%" p={3} pl={6}>
                  <Heading mb={6}>LOGIN FAILED</Heading>
                  <Text mb={2} fontWeight="bold">
                    IT LOOKS LIKE WE DON’T RECOGNISE THIS ACCOUNT
                  </Text>
                  <Text mb={6}>
                    We cannot recognise the details of the account. Please try signing up
                  </Text>
                  <Button onClick={onClose} variantColor="brand" textTransform="uppercase">
                    Go to sign up
                  </Button>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AuthStatusModal
